import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { observer } from 'mobx-react';
import { isEmpty } from 'lodash';

import PDF from '../component/pdf';
import Title from '../component/title';
import HeadPdf from '../component/head-pdf';
import FootPdf from '../component/foot-pdf';
import moIndex from '../store';
import IndustryTrend from './component/industry-trend';
import IndustryTrendTable from './component/industry-trend-table';
import moDemandPdf from './store';

interface IProps {}
interface IState {}

const Industry = (props: IProps, state: IState) => {
  const navi = useNavigate();
  const { trendQuarter } = moDemandPdf;

  useEffect(() => {
    return () => {};
  }, []);

  return (
    <section id="recuit">
      <PDF>
        <section className="recruitment-pdf-warp">
          <HeadPdf
            onetitle="人力资源核心指标"
            twotitle={moIndex.industry.name}/>
          <section className="recruitment-top-title">
            <Title title="招聘趋势" bigTitle="人力需求" />
            <p className="details">
              统计说明：招聘量热度 =
              本月招聘量在最近24个月的招聘量排名（百分位值）
            </p>
            <p className="details">
              招聘薪酬涨幅热度 =
              本月招聘薪酬的环比变化率在最近24个月内的环比变化率排名（百分位值）
            </p>
            <IndustryTrend />
            <IndustryTrendTable />
            <section className="say-Details">
              <p>解读：</p>
              <p>
                {!isEmpty(trendQuarter) &&
                  trendQuarter[trendQuarter.length - 1].amount_change > 0 &&
                  trendQuarter[trendQuarter.length - 1].salary_change > 0 &&
                  `· ${
                    trendQuarter[trendQuarter.length - 1].time_str
                  }「 招聘量 」、「 招聘薪酬 」同时出现上涨`}
                {!isEmpty(trendQuarter) &&
                  trendQuarter[trendQuarter.length - 1].amount_change < 0 &&
                  trendQuarter[trendQuarter.length - 1].salary_change < 0 &&
                  `· ${
                    trendQuarter[trendQuarter.length - 1].time_str
                  }「 招聘量 」、「 招聘薪酬 」同时出现下降`}
                {!isEmpty(trendQuarter) &&
                  trendQuarter[trendQuarter.length - 1].amount_change > 0 &&
                  trendQuarter[trendQuarter.length - 1].salary_change < 0 &&
                  `· ${
                    trendQuarter[trendQuarter.length - 1].time_str
                  }「 招聘量 」上涨,「 招聘薪酬 」下降`}
                {!isEmpty(trendQuarter) &&
                  trendQuarter[trendQuarter.length - 1].amount_change < 0 &&
                  trendQuarter[trendQuarter.length - 1].salary_change > 0 &&
                  `· ${
                    trendQuarter[trendQuarter.length - 1].time_str
                  }「 招聘量 」下降,「 招聘薪酬 」上涨`}
              </p>
            </section>
          </section>
          <FootPdf />
        </section>
      </PDF>
    </section>
  );
};

export default observer(Industry);
